import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { getToken } from '@/utils/token'
import { getApplyId, getExpired, removeApplyId, removeExpired, getVitaInfoType, removeIsInvite, removeInternalReferralCode, removeCampusAmbassadorReferralCode } from '@/utils/resumeParams'
import { removeApply } from '@/api/vita'


Vue.use(VueRouter)

const routes = [
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('../views/maintenance/maintenance.vue')
  },
  {
    meta: {
      title: '格力电器招聘'
    },
    path: '/',
    name: 'mainIndex',
    component: () => import('../views/MainIndex/mainIndex')
  },
  {
    meta: {
      title: '校园招聘-职位列表',
      titleSocial: '社会招聘-职位列表'
    },
    path: '/jobList',
    name: 'jobList',
    component: () => import('../views/job/jobList/jobList')
  },
  {
    meta: {
      title: '搜索职位'
    },
    path: '/jobSearch',
    name: 'jobSearch',
    component: () => import('../views/job/jobSearch/jobSearch')
  },
  {
    meta: {
      title: '面试站点(1/9)',
      titleExpired: '面试站点(1/14)'
    },
    path: '/interviewPlace',
    name: 'interviewPlace',
    component: () => import('../views/vitaInfo/interviewPlace/interviewPlace')
  },
  {
    meta: {
      title: '个人基本信息(2/9)',
      titleExpired: '个人基本信息(2/14)',
      titleSocial: '基本信息'
    },
    path: '/personalInfo',
    name: 'personalInfo',
    component: () => import('../views/vitaInfo/personalInfo/personalInfo')
  },
  {
    meta: {
      title: '期望薪资(3/9)',
      titleExpired: '期望薪资(3/14)'
    },
    path: '/salary',
    name: 'salary',
    component: () => import('../views/vitaInfo/salary/salary')
  },
  {
    meta: {
      titleExpired: '教育背景(4/14)',
      titleSocial: '社会招聘-个人履历'
    },
    path: '/eduBackground',
    name: 'eduBackground',
    component: () => import('../views/vitaInfo/eduBackground/eduBackground')
  },
  {
    meta: {
      titleExpired: '家庭情况(5/14)',
      titleSocial: '社会招聘-个人履历'
    },
    path: '/familyInfo',
    name: 'familyInfo',
    component: () => import('../views/vitaInfo/familyInfo/familyInfo')
  },
  {
    meta: {
      title: '个人履历'
    },
    path: '/workExperience',
    name: 'workExperience',
    component: () => import('../views/vitaInfo/workExperience/workExperience')
  },
  {
    meta: {
      title: '项目经验(4/9)',
      titleExpired: '项目经验(6/14)',
      titleSocial: '社会招聘-个人履历'
    },
    path: '/projectExperience',
    name: 'projectExperience',
    component: () => import('../views/vitaInfo/projectExperience/projectExperience')
  },
  {
    meta: {
      titleExpired: '实习经验(7/14)'
    },
    path: '/internships',
    name: 'internships',
    component: () => import('../views/vitaInfo/internships/internships')
  },
  {
    meta: {
      titleExpired: '语言能力(8/14)'
    },
    path: '/langAbility',
    name: 'langAbility',
    component: () => import('../views/vitaInfo/langAbility/langAbility')
  },
  {
    meta: {
      titleExpired: '证书(9/14)'
    },
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/vitaInfo/certificate/certificate')
  },
  {
    meta: {
      title: '附加信息(5/9)',
      titleExpired: '附加信息(10/14)'
    },
    path: '/additionalInfo',
    name: 'additionalInfo',
    component: () => import('../views/vitaInfo/additionalInfo/additionalInfo')
  },
  {
    meta: {
      title: '附件(6/9)',
      titleExpired: '附件(11/14)'
    },
    path: '/annex',
    name: 'annex',
    component: () => import('../views/vitaInfo/annex/annex')
  },
  {
    meta: {
      title: '推荐信息',
      titleExpired: '推荐信息',
      titleSocial: '推荐信息'
    },
    path: '/recommendedInfo',
    name: 'recommendedInfo',
    component: () => import('../views/vitaInfo/recommendedInfo/recommendedInfo')
  },
  {
    meta: {
      title: '简历附件(7/9)',
      titleExpired: '简历附件(12/14)',
      titleSocial: '简历附件'
    },
    path: '/vitaAnnex',
    name: 'vitaAnnex',
    component: () => import('../views/vitaInfo/vitaAnnex/vitaAnnex')
  },
  {
    meta: {
      title: '确认信息属实(8/9)',
      titleExpired: '确认信息属实(13/14)',
      titleSocial: '确认信息'
    },
    path: '/confirm',
    name: 'confirm',
    component: () => import('../views/vitaInfo/confirm/confirm')
  },
  {
    meta: {
      title: '预览提交(9/9)',
      titleExpired: '预览提交(14/14)',
      titleSocial: '预览提交'
    },
    path: '/preview',
    name: 'preview',
    component: () => import('../views/vitaInfo/preview/preview')
  },
  {
    meta: {
      title: '校园招聘-职位详情',
      titleSocial: '社会招聘-职位详情'
    },
    path: '/jobDetail',
    name: 'jobDetail',
    component: () => import('../views/job/jobDetail/jobDetail')
  },
  {
    meta: {
      title: '我的简历'
    },
    path: '/myVita',
    name: 'myVita',
    component: () => import('../views/vitaInfo/myVita/myVita'),
    beforeEnter: (to, from, next) => {
      if (to.query.vitaType === '2') {
        document.title = '我的社招简历'
      } else {
        document.title = '我的校招简历'
      }
      next()
    }
  },
  {
    meta: {
      title: '投递记录'
    },
    path: '/records',
    name: 'records',
    component: () => import('../views/records/records'),
    beforeEnter: (to, from, next) => {
      if (to.query.vitaType === '2') {
        document.title = '社招投递记录'
      } else {
        document.title = '校招投递记录'
      }
      next()
    }
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/Main/Main')
  }, {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login')
  },
  {
    meta: {
      title: '个人中心'
    },
    path: '/personal',
    name: 'personal',
    component: () => import('../views/personal/personal')
  },
  {
    meta: {
      title: '更换手机号'
    },
    path: '/updateMobile',
    name: 'updateMobile',
    component: () => import('../views/personal/settings/updateMobile')
  },
  {
    meta: {
      title: '账号设置'
    },
    path: '/accountSetting',
    name: 'accountSetting',
    component: () => import('../views/personal/settings/accountSetting')
  },
  {
    meta: {
      title: '更换邮箱'
    },
    path: '/updateEmail',
    name: 'updateEmail',
    component: () => import('../views/personal/settings/updateEmail')
  },
  {
    path: '/serviceAgreement',
    name: 'serviceAgreement',
    component: () => import('../views/serviceAgreement/serviceAgreement')
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: () => import('../views/privacyAgreement/privacyAgreement')
  },
  {
    meta: {
      title: '联系我们'
    },
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/contactUs/contactUs')
  },
  {
    meta: {
      title: '面试安排'
    },
    path: '/interview',
    name: 'Interview',
    component: () => import('../views/interview'),
    beforeEnter: (to, from, next) => {
      store.dispatch('applicant/checkLogin', to)
        .then((redirect) => {
          redirect ? next(redirect) : next()
        })
    }
  },
  {
    meta: {
      title: '面试安排'
    },
    path: '/interviewDetail',
    name: 'InterviewDetail',
    component: () => import('../views/interview/detail'),
    beforeEnter: (to, from, next) => {
      store.dispatch('applicant/checkLogin', to)
        .then((redirect) => {
          redirect ? next(redirect) : next()
        })
    }
  },
  {
    meta: {
      title: '微信登录'
    },
    path: '/wechatLogin',
    name: 'WechatLogin',
    component: () => import('../views/login/wechatLogin')
  },
  {
    meta: {
      title: '微信登录'
    },
    path: '/wechatLoginCallback',
    name: 'WechatLoginCallback',
    component: () => import('../views/login/wechatLoginCallback')
  },
  {
    meta: {
      title: '绑定手机号'
    },
    path: '/bindMobile',
    name: 'BindMobile',
    component: () => import('../views/login/bindMobile')
  },
  {
    meta: {
      title: '绑定邮箱'
    },
    path: '/bindEmail',
    name: 'BindEmail',
    component: () => import('../views/bindEmail/bindEmail')
  },
  {
    meta: {
      title: '上传简历'
    },
    path: '/aiUploadVita',
    name: 'aiUploadVita',
    component: () => import('../views/vitaInfo/uploadVita/aiUploadVita')
  },
  {
    meta: {
      title: '客服'
    },
    path: '/customerService',
    name: 'customerService',
    component: () => import('../views/customerService/index')
  },
  {
    meta: {
      title: '宿舍抽签'
    },
    path: '/lottery',
    name: 'lottery',
    component: () => import('../views/lottery/index')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    // x代表横坐标，y代表纵坐标
    return { x: 0, y: 0 }
  }
})

// const vitaList = ['/interviewPlace', '/personalInfo', '/salary', '/eduBackground', '/familyInfo', '/projectExperience', '/internships', '/langAbility', '/certificate', '/additionalInfo', '/annex', '/vitaAnnex', '/confirm', '/preview']

const whiteList = ['/login', '/', '/jobList', '/jobDetail', '/jobSearch', '/main', '/contactUs', '/interview', '/interviewDetail', '/wechatLogin','/wechatLoginCallback', '/bindMobile', '/bindEmail', '/customerService']
// const whiteList = ['/login', '/', '/jobList', '/jobDetail', '/jobSearch','/contactUs','/interview', '/interviewDetail', '/wechatLogin', '/bindMobile'] // no redirect whitelist

const vitaList = ['/interviewPlace', '/personalInfo', '/salary', '/eduBackground', '/familyInfo', '/projectExperience', '/workExperience', '/internships', '/langAbility', '/certificate', '/additionalInfo', '/annex', '/vitaAnnex', '/confirm', '/preview', '/aiUploadVita', '/recommendedInfo']
// 需要绑定检查的页面（已登录但未完成绑定时重定向到绑定页）
const needBindCheckPages = ['/personal', '/records', '/myVita', '/accountSetting', '/lottery', ...vitaList]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// 维护时间检查缓存
let maintenanceCheckCache = {
  promise: null,
  isMaintenance: null,
  checkTime: null
}

// 检查是否在维护时间内（缓存1小时）
function checkMaintenanceTime () {
  // 如果1小时内检查过，直接使用缓存
  if (maintenanceCheckCache.checkTime && Date.now() - maintenanceCheckCache.checkTime < 3600000) {
    return maintenanceCheckCache.isMaintenance
  }

  // 如果正在检查中，返回 Promise
  if (maintenanceCheckCache.promise) {
    return maintenanceCheckCache.promise
  }

  maintenanceCheckCache.promise = import('@/api/user').then(({ getMaintenanceTime }) => {
    return getMaintenanceTime().then(res => {
      try {
        if (res.code === 200 && res.data && res.data.ctime && res.data.utime) {
          const now = new Date()
          const startTime = new Date(res.data.ctime)
          const endTime = new Date(res.data.utime)

          // 判断当前时间是否在维护窗口内
          const isMaintenance = now >= startTime && now <= endTime
          maintenanceCheckCache.isMaintenance = isMaintenance
        } else {
          maintenanceCheckCache.isMaintenance = false
        }
      } catch (error) {
        console.error('维护时间检查失败:', error)
        maintenanceCheckCache.isMaintenance = false
      }
      maintenanceCheckCache.checkTime = Date.now()
      maintenanceCheckCache.promise = null
      return maintenanceCheckCache.isMaintenance
    }).catch(() => {
      // 接口异常时，不阻塞正常访问
      maintenanceCheckCache.isMaintenance = false
      maintenanceCheckCache.checkTime = Date.now()
      maintenanceCheckCache.promise = null
      return false
    })
  })

  return maintenanceCheckCache.promise
}


router.beforeEach(async (to, from, next) => {
  // 如果已经是维护页面，直接放行
  if (to.path === '/maintenance') {
    next()
    return
  }

  // 检查系统维护状态
  try {
    const isMaintenance = await checkMaintenanceTime()
    if (isMaintenance) {
      next('/maintenance')
      return
    }
  } catch (error) {
    console.error('检查维护状态失败:', error)
  }
  // 非简历字段页面删除本地是否邀请更新简历字段和applyId
  if (vitaList.indexOf(to.path) === -1) {
    removeExpired()
    removeIsInvite()
    removeApplyId()
    removeCampusAmbassadorReferralCode()
    removeInternalReferralCode()
  }
  const userDevice = [
    'iPhone',
    'iPad',
    'Android',
    'SymbianOS',
    'iPod',
    'Windows Phone',
    'Phone'
  ].some((agentType) => navigator.userAgent.indexOf(agentType) !== -1)

  console.log(window.location.hostname)
  if (!userDevice) {
    if (window.location.hostname.includes('ts')) {
      location.href = 'https://tszhaopin.greeyun.com/'
    } else {
      location.href = 'https://zhaopin.greeyun.com/'
    }
  }
  // 邀请更新简历时页面标题不同
  if (getExpired() === 'true' && to.meta.titleExpired !== undefined) {
    document.title = to.meta.titleExpired
  } else if (to.meta.title !== undefined) {
    document.title = to.meta.title
  } else {
    document.title = '格力电器校园招聘'
  }
  if (to.meta.titleSocial !== undefined) {
    if (getVitaInfoType() === '2') {
      document.title = to.meta.titleSocial
    }
  }
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
    } else if (needBindCheckPages.indexOf(to.path) !== -1) {
      // 已登录用户访问需认证页面时，检查绑定状态
      try {
        const { getUserInfo } = await import('@/api/user')
        const res = await getUserInfo()
        if (res.code === 200 && res.data) {
          const { bindPhone, bindEmail, phone, email } = res.data
          const isPhoneBound = bindPhone === 1 || bindPhone === '1' || !!phone
          const isEmailBound = bindEmail === 1 || bindEmail === '1' || !!email

          const currentPath = to.fullPath || to.path

          if (!isPhoneBound) {
            next({ path: '/bindMobile', query: { redirect: currentPath } })
            return
          }
          if (!isEmailBound) {
            next({ path: '/bindEmail', query: { redirect: currentPath } })
            return
          }
        }
      } catch (e) {
        console.error('检查绑定状态失败:', e)
      }
      next()
    } else {
      next()
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free Login whitelist, go directly
      next()
    } else {
      // 跳转个人页时登陆后直接跳转to.path
      if (to.name === 'personal' || to.name === 'records' || to.name === 'accountSetting' || to.name === 'lottery') {
        next(`/login?redirect=${to.fullPath || to.path}`)
      } else {
        next(`/login?redirect=${from.fullPath || from.path}`)
      }
    }
  }
})

export default router
